import { Close, Fullscreen } from "@mui/icons-material";
import {
  AppBar,
  Dialog,
  // DialogTitle,
  // Divider,
  IconButton,
  Toolbar,
  Typography,
  // useMediaQuery,
} from "@mui/material";
import React from "react";

const CustomDialog = ({
  open,
  handleClose,
  heading,
  children,
  forceFullScreen = false,
  sx,
}) => {
  // const fullScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const fullScreen = false;
  return (
    <Dialog
      fullScreen={forceFullScreen ? true : fullScreen}
      open={open}
      onClose={handleClose}
      sx={sx}
    >
      <AppBar
        sx={{ position: "relative", ...(!fullScreen && { minWidth: 500 }) }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h5" component="div">
            {heading}
          </Typography>
        </Toolbar>
      </AppBar>

      {children}
    </Dialog>
  );
};

export default CustomDialog;
